import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { WindowEventsService } from 'src/app/services/window-events.service';
import { LoggingMessageService } from 'src/app/services/logging-message.service';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';

@Component({
  standalone: true,
  selector: 'app-sso',
  template: ``
})

export class SsoComponent implements OnInit {
  availableSubscriptions: string;
  selectedSubscriptionID: number;

  constructor(
    public logger: LoggingMessageService,
    public authService: AuthService,
    public windowEvents: WindowEventsService,
    private subscriptionService: SubscriptionChangeService) {
  }

  ngOnInit() {
    this.selectedSubscriptionID = this.subscriptionService.SelectedSubscription;
    this.availableSubscriptions = this.subscriptionService.AvailableSubscriptionsString;
    this.requestFreshToken();
  }

  private requestFreshToken() {
    setTimeout(() => {
        this.logger.debug('app.component', 'requestFreshToken', this.selectedSubscriptionID, this.availableSubscriptions, 'getting fresh token after facility change service response', '');
        this.authService.getNewAccessToken(environment.TokenServiceApi, environment.TokenServiceMedia, environment.UseTestToken, environment.UseCookies, environment.CookieName);
    }, 0);
  }
}
